import { readonly, ref } from "vue";
import Cookies from 'js-cookie';

/**
 * 
 * @param {Array<{rfc5646: string, iso6391: string, name: string}>} supportedLanguages 
 * @returns 
 */
export function useLanguagePreference(supportedLanguages) {
    const preferredLanguageKey = 'roleplayPreferredLanguage';
    const defaultLanguage = findLang(navigator.language)?.rfc5646 ?? 'en-US';
    
    /**
     * @type {import('vue').Ref<string>} rfc5646 language code
     */
    const lang = ref(
        Cookies.get(preferredLanguageKey)
            ? findLang(Cookies.get(preferredLanguageKey))?.rfc5646 ?? defaultLanguage
            : defaultLanguage
    );

    function findLang(lang) {
        return supportedLanguages.find(supportedLang => 
            supportedLang.rfc5646.toLowerCase() === lang.toLowerCase() ||
            supportedLang.iso6391.toLowerCase() === lang.toLowerCase() ||
            supportedLang.name.toLowerCase() === lang.toLowerCase()
        );
    }

    function isLangSupported(lang) {
        return !!findLang(lang);
    }

    /**
     * 
     * @param {string} newLang Can be in any format, but will be converted to rfc5646
     */
    function setLang(newLang) {
        const language = findLang(newLang);

        if (!language) {
            throw new Error(`Language ${newLang} is not supported`);
        }

        Cookies.set(preferredLanguageKey, language.rfc5646, { expires: 365 });
        lang.value = language.rfc5646;
    }

    return {
        lang: readonly(lang),
        setLang,
        findLang,
        isLangSupported,
    }
}
